<template>
    <div class="hardware-manage-form">
        <el-col :span="24">
            <el-button
                @click="$router.go(-1)"
                size="medium"
            >返回
            </el-button>
            <el-button
                type="primary"
                size="medium"
                @click="submitForm"
            >保存
            </el-button>
        </el-col>

        <div
            class="form-wrapper"
            :style="{ width: '100%', height: windowHeight - 180 + 'px' }"
        >
            <el-form
                label-width="150px"
                ref="form"
                :model="form"
                :rules="rules"
            >
                <el-form-item
                    label="设备编码"
                    prop="equipmentId"
                >
                    <el-input
                        placeholder="请输入设备编码"
                        maxlength="20"
                        show-word-limit
                        v-model.trim="form.equipmentId"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="设备类型"
                    prop="equipType"
                >
                    <el-select
                        size="medium"
                        v-model="form.equipType"
                        placeholder="请选择设备类型"
                        value-key="code"
                        @change="changeType"
                    >
                        <el-option
                            v-for="(item, idx) in typeList"
                            :key="idx"
                            :label="item.value"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="设备型号"
                    prop="useType"
                >
                    <el-select
                        size="medium"
                        v-model="form.moduleType"
                        placeholder="请选择设备型号"
                        value-key="code"
                    >
                        <el-option
                            v-for="(item, idx) in moduleList"
                            :key="idx"
                            :label="item.value"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item-->
<!--                    label="设备用途"-->
<!--                    prop="useType"-->
<!--                    v-if="form.equipType.code != 10005 && form.equipType.code != 10006"-->
<!--                >-->
<!--                    <el-select-->
<!--                        size="medium"-->
<!--                        v-model="form.useType"-->
<!--                        placeholder="请选择使用场景"-->
<!--                        value-key="code"-->
<!--                    >-->
<!--                        <el-option-->
<!--                            v-for="(item, idx) in useTypeList"-->
<!--                            :key="idx"-->
<!--                            :label="item.value"-->
<!--                            :value="item"-->
<!--                        ></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
            </el-form>
        </div>
    </div>
</template>
<script>
    /* utils */
    import mixin from "@/mixins/windowResize";

    /* components */

    /* api */
    import {
        findDicsByCode,
        subFindDicsByCode,
        addEquipmentLibrary,
        getScancodeEquipmentById,
    } from "@/api/equipmentLibrary";

    export default {
        mixins: [mixin],
        components: {},
        computed: {},
        data() {
            return {
                // 新增 / 编辑
                type: "add",
                // 保存成功后提示语
                messsage: "保存成功",
                // 请求表单
                form: {
                    scanId: "",
                    equipmentId: "",
                    state: 1,
                    equipType: {
                        code: "",
                        value: "",
                    },
                    useType: {
                        code: "",
                        value: "",
                    },
                    moduleType: {
                        code: '',
                        value: ''
                    }
                },
                rules: {
                    equipmentId: [
                        {required: true, message: "请输入设备ID", trigger: "blur"},
                        {
                            min: 1,
                            max: 20,
                            message: "请输入 20 个以内有效字符",
                            trigger: "blur",
                        },
                    ],
                },
                typeList: [],
                useTypeList: [],
                moduleList: []
            };
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                Promise.all([subFindDicsByCode({
                    dicCode: 'deviceModel'
                })
                    .then(res => res.data)
                    .then(data => {
                        this.moduleList = data.data;
                        this.form.moduleType = this.moduleList[0];
                    }),
                    this.findDicsByCodes()
                ])
                    .then(() => {
                        let scanId = this.$route.query.scanId;
                        if (scanId) {
                            this.type = "edit";
                            this.form.scanId = scanId;
                            this.getScancodeEquipmentById();
                        } else this.type = "add";
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$toast.clear();
                    });
            },
            //获取类型
            findDicsByCodes() {
                return findDicsByCode().then((res) => {
                    let data = res.data.data;
                    this.typeList = data;
                    this.form.equipType = this.typeList[0];
                    return this.getUserTypeList();
                });
            },
            getUserTypeList() {
                return subFindDicsByCode({
                    dicCode: this.form.equipType.code,
                }).then((res) => {
                    let data = res.data.data;
                    this.useTypeList = data;
                    this.form.useType = this.useTypeList[0];
                });
            },
            getScancodeEquipmentById() {
                getScancodeEquipmentById({
                    scanId: this.form.scanId,
                })
                    .then((res) => {
                        let _res = res.data;
                        if (_res.code != 200) return Promise.reject(_res.msg);
                        else return _res.data;
                    })
                    .then((res) => {
                        this.form.equipmentId = res.equipmentId;
                        this.form.state = res.state;
                        let equipType = this.typeList.find(
                            (item) => item.code == res.equipType
                        );
                        let useType = this.useTypeList.find(
                            (item) => item.code == res.useType
                        );
                        this.form.equipType = equipType;
                        this.form.useType = useType;
                    });
            },

            //搜索
            changeType() {
                this.getUserTypeList();
            },

            // 提交
            submitForm() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        let form = {
                            equipmentId: this.form.equipmentId,
                            equipmentName: "",
                            equipType: this.form.equipType.code,
                            equipTypeName: this.form.equipType.value,
                            useType: 0,
                            useTypeName:  '',
                            moduleId: this.form.moduleType.code,
                            moduleName: this.form.moduleType.value,
                        };
                        if (this.type == "add") {
                            this.addEquipmentLibraryFunc(form);
                        } else {
                            //
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            // 新增心育科普通知
            addEquipmentLibraryFunc(form) {
                addEquipmentLibrary(form)
                    .then((res) => {
                        let _res = res.data;
                        if (_res.code != 200) return Promise.reject(_res.msg);
                        else return _res.data;
                    })
                    .then((data) => {
                        this.$message({
                            message: "保存成功",
                            type: "success",
                        });
                        this.$router.go(-1);
                    })
                    .catch((msg) => {
                        this.$message({
                            message: msg,
                            type: "error",
                        });
                    });
            },
            // 修改心育科普通知
            // updateHeartEduNotice(form) {
            //     updateHeartEduNotice(form)
            //         .then((res) => {
            //             let _res = res.data;
            //             if (_res.code != 200) return Promise.reject(_res.msg);
            //             else return _res.data;
            //         })
            //         .then((data) => {
            //             this.$message({
            //                 message: this.messsage,
            //                 type: "success",
            //             });
            //             this.$router.go(-1);
            //         })
            //         .catch((msg) => {
            //             this.$message({
            //                 message: msg,
            //                 type: "error",
            //             });
            //         });
            // },
        },
    };
</script>
<style lang="scss" scoped>
    .hardware-manage-form {
        padding: 15px;

        .el-col {
            border-bottom: 1px solid #e7eaec;
            padding-bottom: 10px;
            margin-bottom: 10px;
        }

        .form-wrapper {
            overflow-y: auto;
        }

        .el-form {
            width: 810px;
            margin: 0 auto;

            /deep/ .upload-file-item {
                width: 200px !important;

                img {
                    width: 100% !important;
                    min-height: 110px;
                    margin: 0;
                    border: 1px dashed #409eff;
                    box-sizing: border-box;
                    margin: 0 !important;
                }

                .file-name {
                    display: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/hardwareManage/form.vue